import "@lottiefiles/lottie-player";
import * as lottie from 'lottie-web';
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('header.main-header'), mainMenu = document.querySelector('.main-menu'), toggleMenus = document.querySelectorAll(".toggle-menu"), hamburgerWhite = document.querySelector('#hamburger__white'), hamburgerBlack = document.querySelector('#hamburger__black'), navgationAnimation = document.querySelector('#hamburger-animation-canvas'), body = document.querySelector('body'), modules = document.querySelector('.modules');
    // setBodyMarginFromHeader()
    setTransparentHeaderChecker();
    checkScroll();
    // Setup navigation animation
    function setupNavigationAnimation() {
        const animationData = '/lottie/navigation.json';
        const options = {
            container: navgationAnimation,
            renderer: 'canvas',
            loop: false,
            autoplay: false,
            path: animationData,
            rendererSettings: {
                canvas: {
                    preserveAspectRatio: "xMidYMax slice"
                }
            }
        };
        return lottie.loadAnimation(options);
    }
    let anim = setupNavigationAnimation();
    window.addEventListener('resize', () => {
        // If we resize, reset the navigation animation and close the menu
        closeNavigation();
        anim.destroy();
        anim = setupNavigationAnimation();
    }, false);
    /**
     * Closes the navigation menu
     * @returns {void}
     * */
    function closeNavigation() {
        toggleMenus.forEach(toggleMenu => {
            const mainMenuState = body.getAttribute('data-menu-state');
            const lottiePlayers = document.querySelectorAll("header lottie-player");
            if (mainMenuState === 'opened') {
                body.setAttribute('data-menu-state', 'closed');
                toggleMenu.setAttribute('aria-expanded', 'false');
                lottiePlayers.forEach((player) => {
                    player.getLottie().playSegments([7, 0], true);
                });
                anim.playSegments([16, 31], true);
                const links = document.querySelectorAll('.main-menu__box--wrapper a');
                links.forEach((link) => {
                    link.classList.remove('is-revealed');
                });
            }
        });
    }
    /**
     * Checks if the first module is a showcase hero or image hero and sets the header to transparent if so.
     */
    function setTransparentHeaderChecker() {
        const modules = document.querySelector('div.modules');
        // If no modules are found on the page, make the hamburger black
        if (!modules.firstElementChild) {
            hamburgerWhite.style.display = 'none';
            hamburgerBlack.style.display = 'block';
            return;
        }
        // If the first module on the page is the showcase hero, image hero, or page header module, add the transparent class
        if (modules?.firstElementChild.classList.contains('showcase_hero') || modules?.firstElementChild.classList.contains('image_hero') || modules?.firstElementChild.classList.contains('page_header')) {
            header.classList.add('transparent');
            if (!modules?.firstElementChild.classList.contains('page_header')) {
                // Updating hamburger icon to be white
                hamburgerWhite.style.display = 'block';
                hamburgerBlack.style.display = 'none';
            }
            else {
                // Updating hamburger icon to be black
                hamburgerWhite.style.display = 'none';
                hamburgerBlack.style.display = 'block';
            }
        }
        else {
            // Updating hamburger icon to be black
            hamburgerWhite.style.display = 'none';
            hamburgerBlack.style.display = 'block';
        }
    }
    function checkScroll() {
        // Fix: Nav error when no modules are found
        if (!modules.firstElementChild)
            return;
        if (header) {
            // If the first module is the showcase hero, image hero, or page header module and the image hero is using a full height, add the transparent class
            if ((modules?.firstElementChild.classList.contains('showcase_hero')
                || (modules?.firstElementChild.classList.contains('image_hero') && !modules?.firstElementChild.classList.contains('image_hero__smaller'))
                || modules?.firstElementChild.classList.contains('page_header')) && (window.scrollY <= window.innerHeight - 57)) {
                setHeaderToTransparent();
            }
            else if (modules?.firstElementChild.classList.contains('image_hero__smaller') && (window.scrollY <= window.innerWidth - 57)) {
                // If the first module is an image hero smaller and the image hero is using a square image, add the transparent class
                setHeaderToTransparent();
            }
            else {
                setHeaderToSolid();
            }
        }
        function setHeaderToTransparent() {
            // Updating navigation to be transparent
            header.classList.add('transparent');
            header.classList.contains('scrolled') ? header.classList.remove('scrolled') : null;
            header.classList.contains('logo__orange') ? header.classList.remove('logo__orange') : null;
            if (!modules?.firstElementChild.classList.contains('page_header')) {
                // Updating hamburger icon to be white
                hamburgerWhite.style.display = 'block';
                hamburgerBlack.style.display = 'none';
            }
            else {
                // Updating hamburger icon to be black
                hamburgerWhite.style.display = 'none';
                hamburgerBlack.style.display = 'block';
                // Change the logo to be orange
                header.classList.add('logo__orange');
            }
        }
        function setHeaderToSolid() {
            // Updating navigation to be white
            header.classList.contains('transparent') ? header.classList.remove('transparent') : null;
            header.classList.add('scrolled');
            // Updating hamburger icon to be black
            hamburgerWhite.style.display = 'none';
            hamburgerBlack.style.display = 'block';
        }
    }
    if (header)
        window.addEventListener('scroll', checkScroll);
    /**
     * Apply click event listener to hamburgers site-wide for the styling and to calculate header height on click.
     */
    toggleMenus.forEach(toggleMenu => {
        toggleMenu.addEventListener('click', (e) => {
            e.preventDefault();
            const mainMenuState = body.getAttribute('data-menu-state');
            const lottiePlayers = document.querySelectorAll("header lottie-player");
            if (!mainMenuState || mainMenuState === 'closed') {
                body.setAttribute('data-menu-state', 'opened');
                toggleMenu.setAttribute('aria-expanded', 'true');
                lottiePlayers.forEach((player) => {
                    player.getLottie().playSegments([0, 16], true);
                });
                anim.playSegments([0, 16], true);
                const links = document.querySelectorAll('.main-menu__box--wrapper a');
                setTimeout(() => {
                    links.forEach((link, index) => {
                        setTimeout(() => {
                            link.classList.add('is-revealed');
                        }, index * 100);
                    });
                }, 150);
            }
            else {
                body.setAttribute('data-menu-state', 'closed');
                toggleMenu.setAttribute('aria-expanded', 'false');
                lottiePlayers.forEach((player) => {
                    player.getLottie().playSegments([7, 0], true);
                });
                anim.playSegments([16, 31], true);
                const links = document.querySelectorAll('.main-menu__box--wrapper a');
                links.forEach((link) => {
                    link.classList.remove('is-revealed');
                });
            }
        });
    });
});
